export function setLightTheme() {
  document.documentElement.classList.add('light')
}
export function setDarkTheme() {
  document.documentElement.classList.remove('light')
}
export function isLightTheme() {
  return document.documentElement.classList.contains('light')
}
